import { defineModuleEvidenceContract } from './moduleEvidenceContract';
import { SGA_SPEND_SCHEMA_VERSIONS } from './schemaVersions';
import { SGA_SPEND_MODULE_EVIDENCE_CONTRACT } from './sgaSpendModuleEvidenceContract';

const realEstateFootprintEvidenceEntry =
  SGA_SPEND_MODULE_EVIDENCE_CONTRACT.entries.real_estate_footprint;

export const REAL_ESTATE_FOOTPRINT_STATE_KEYS = {
  governedSnapshot: realEstateFootprintEvidenceEntry.stateKey,
  spendAttested: 'real_estate_footprint_spend_attested',
  spendGoverned: 'real_estate_footprint_spend_governed',
  addressableAttested: 'real_estate_footprint_addressable_attested',
  addressableGoverned: 'real_estate_footprint_addressable_governed',
  programAttested: 'real_estate_footprint_program_attested',
  programGoverned: 'real_estate_footprint_program_governed',
  spendSnapshot: 'real-estate-footprint-spend-snapshot',
  addressableSnapshot: 'real-estate-footprint-addressable-snapshot',
  programSnapshot: 'real-estate-footprint-program-snapshot',
} as const;

export const REAL_ESTATE_FOOTPRINT_EVIDENCE_KEYS = {
  governedSnapshot: realEstateFootprintEvidenceEntry.evidenceKey,
  spendSnapshot: REAL_ESTATE_FOOTPRINT_STATE_KEYS.spendSnapshot,
  addressableSnapshot: REAL_ESTATE_FOOTPRINT_STATE_KEYS.addressableSnapshot,
  programSnapshot: REAL_ESTATE_FOOTPRINT_STATE_KEYS.programSnapshot,
} as const;

export const REAL_ESTATE_FOOTPRINT_BINDING_PLACEHOLDERS = {
  opportunityUsd: realEstateFootprintEvidenceEntry.bindingPlaceholders[0],
} as const;

export const REAL_ESTATE_FOOTPRINT_SCHEMA_VERSIONS = {
  manifest: SGA_SPEND_SCHEMA_VERSIONS.manifest,
  governedSnapshot: realEstateFootprintEvidenceEntry.schemaVersion,
} as const;

export const REAL_ESTATE_FOOTPRINT_MODULE_EVIDENCE_CONTRACT =
  defineModuleEvidenceContract(
    'real-estate-footprint',
    {
      governed_snapshot: realEstateFootprintEvidenceEntry,
    },
    {
      evidenceKeys: Object.values(REAL_ESTATE_FOOTPRINT_EVIDENCE_KEYS),
      sourceClasses: [realEstateFootprintEvidenceEntry.sourceClass],
      contextKinds: [realEstateFootprintEvidenceEntry.contextKind],
      schemaVersions: Object.values(REAL_ESTATE_FOOTPRINT_SCHEMA_VERSIONS),
      stateKeys: Object.values(REAL_ESTATE_FOOTPRINT_STATE_KEYS),
      bindingPlaceholders: Object.values(
        REAL_ESTATE_FOOTPRINT_BINDING_PLACEHOLDERS,
      ),
    },
  );

export type RealEstateFootprintModuleEvidenceContract =
  typeof REAL_ESTATE_FOOTPRINT_MODULE_EVIDENCE_CONTRACT;
